import "./style/bundle-section-body.scss"

import React from "react"
import { IMinimalProduct } from "@ng-mw/platform-interfaces"
import { ProductList, ProductListVertical } from "@ng-mw/shared-react-components/products"

// Components
import HorizontalScroller from "@modules/shared/HorizontalScroller"
import ProductListCompact from "@ng-mw/shared-react-components/src/modules/products/ProductListCompact"
import { BundleType } from "@modules/debug/DebugTmpFeatureToggles"
import { LocalStorage } from "@ng-mw/shared-react-components"

interface BundleSectionBodyProps {
    products: IMinimalProduct[]
    lastItemCTA?: React.ReactNode
    forceShowLastItemCTA?: boolean
}

const BundleSectionBody = ({
    products = [],
    lastItemCTA,
    forceShowLastItemCTA,
}: BundleSectionBodyProps) => {
    // TMP debug different types
    const tmpBundleType: BundleType = LocalStorage.get("DEBUG_BUNDLE_TYPE")

    // split products into 5 lists of 3 products each - but if theres less than 15 products, just use the available products
    const splitProducts = (products: IMinimalProduct[]): IMinimalProduct[][] => {
        const maxProducts = 15
        const productsToUse = products.slice(0, maxProducts)
        const result: IMinimalProduct[][] = []

        for (let i = 0; i < productsToUse.length; i += 3) {
            result.push(productsToUse.slice(i, i + 3))
        }

        return result
    }

    const productListComponents = splitProducts(products).map((list, index) => {
        if (tmpBundleType === "Compact") {
            return (
                <ProductListCompact
                    key={index}
                    products={list}
                    list="BundleSectionBody"
                />
            )
        }
        if (tmpBundleType === "Vertical") {
            return (
                <ProductListVertical
                    key={index}
                    products={list}
                    list="BundleSectionBody"
                />
            )
        }
        return (
            <ProductList
                key={index}
                products={list}
                list="BundleSectionBody"
            />
        )
    })

    const showCTA = lastItemCTA && (products.length > 15 || forceShowLastItemCTA)
    // If there are more than 15 products or forceShow is true, show a "View All" call to action as last scroll item.
    const viewAllProductsCTA = showCTA && lastItemCTA

    // Flatten and sanitize children to ensure they're valid React elements
    // (avoids issues with cloneElement or mapping)
    const scrollItems = [
        ...React.Children.toArray(productListComponents),
        ...React.Children.toArray(viewAllProductsCTA),
    ]

    return (
        <div className="bundle-section-body">
            <HorizontalScroller height="auto">{scrollItems}</HorizontalScroller>
        </div>
    )
}

export default BundleSectionBody
